export const NAV_BAR_HEIGHT = '3.75rem'
